module.exports = __webpack_public_path__ + "static/media/hospital-symbol.60d9ff8e.svg";